export const BI_EVENTS_IDS = {
  REPLACEMENT_PAGE_SUCCEEDED: 111,
  PAGES_REPLACE_WITH_CUSTOM_PAGE_CHOICE: 110,
  PAGES_REPLACE_TPA_MESSAGE_LOADED: 113,
  PAGE_VARIANTS_PANEL_OPENED: 140,
  PAGE_VARIANTS_PANEL_CLOSED: 141,
  PAGE_VARIANTS_PANEL_ACTION: 142,
  VARIANT_RULE_UPDATE: 133,
  VARIANT_PAGE_ADDED: 134,
};

export const MULTI_SECTION_DELIMITER = '$TPA$';

export const CREATE_RULE_ACTION = 'create';
export const EDIT_RULE_ACTION = 'edit';

export const PAGE_REPLACE_MODAL_ORIGIN = {
  DEFAULT: 'default',
  CUSTOM: 'custom',
};

export const DEFAULT_REPLACER_HELP_URL =
  'https://dev.wix.com/docs/develop-websites/articles/wix-apps/build-a-custom-wix-business-app-page';
